<template>
  <aside
    v-if="!isHiddenHeadAndSideBar"
    class="as"
    :class="{
      shrink: !isSideBarExpanded,
      active: !isSideBarActive,
    }"
  >
    <mq-layout :mq="['lg', 'xlg', 'xl']" class="as__logo__container">
      <router-link :to="{ name: 'home' }" class="as__logo">
        <Logo/>
      </router-link>
      <a href="#" @click.prevent="changeSideBarState" class="as__toggle">
        <SideBarIco/>
      </a>
    </mq-layout>
    <mq-layout :mq="['sm', 'xsm', 'md']" class="as__logo__container">
      <a href="#" class="as__toggle">
        <SideBarIco/>
      </a>
    </mq-layout>
    <!--    <perfect-scrollbar tag="nav" class="as__items" :options="psOptions">-->
    <nav class="as__items">
      <div class="as__item">
        <SidebarMenu/>
      </div>
      <div class="as__item as__item__bottom">
        <ul class="as__menu">
          <li>
            <router-link :to="{ name: 'cabinet' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('cabinet')}">
              <i class="as__menu__link__icon">
                <CabinetIco/>
              </i>
              <span class="as__menu__link__title">Кабинет</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'faq' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('faq') || isSubRouterLinkActive('support') || isSubRouterLinkActive('question')}">
              <i class="as__menu__link__icon">
                <QuestionIco/>
              </i>
              <span class="as__menu__link__title">FAQ (Вопрос/ответ)</span>
            </router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link :to="{ name: 'support' }" class="as__menu__link" :class="{ active: isSubRouterLinkActive('support')}">-->
          <!--              <i class="as__menu__link__icon">-->
          <!--                <HelpIco/>-->
          <!--              </i>-->
          <!--              <span class="as__menu__link__title">Служба поддержки</span>-->
          <!--            </router-link>-->
          <!--          </li>-->
        </ul>
      </div>
    </nav>
    <!--    </perfect-scrollbar>-->
  </aside>
</template>

<script>
import SidebarMenu from '@/components/layouts/SidebarMenu'
import Logo from '@/components/svg/logo_text'
import QuestionIco from '@/components/svg/question'
import SideBarIco from '@/components/svg/sidebar'
import CabinetIco from '@/components/svg/cabinet'

export default {
  name: 'SideBar',
  components: {
    SidebarMenu,
    CabinetIco,
    Logo,
    SideBarIco,
    QuestionIco
  },
  async beforeCreate () {
    await this.$store.dispatch('expiredTasks', this)
    await this.$store.dispatch('unprocessesAppeals', this)
    await this.$store.dispatch('unprocessedLeads', this)
  },
  data () {
    return {
      psOptions: {
        suppressScrollX: true,
        wheelPropagation: false,
        minScrollbarLength: 0
      }
    }
  },
  computed: {
    isHiddenHeadAndSideBar () {
      return !this.$store.state.authToken || this.$store.state.isHiddenHeadAndSideBar
    },
    isSideBarActive () {
      if (this.$store.state.sideBarState === 'expanded') {
        document.documentElement.style.setProperty('--fixed-actions-width', 'calc(100% - 330px)')
      } else document.documentElement.style.setProperty('--fixed-actions-width', 'calc(100% - 140px)')
      return this.$store.state.sideBarState === 'expanded'
    },
    isSideBarExpanded () {
      if (window.innerWidth <= 768) {
        return false
      } else {
        return this.$store.state.sideBarState === 'expanded'
      }
    },
    currentRoute () {
      return this.$route
    }
  },
  watch: {
    '$route' () {
      if (window.innerWidth <= 768) {
        this.$store.dispatch({ type: 'setSideBarState', value: 'nonexpanded' })
        document.querySelectorAll('.as__submenu').forEach(submenu => {
          submenu.querySelector('.as__submenu__link').blur()
        })
      }
    }
  },
  methods: {
    mobileHandle (route) {
      if (window.innerWidth > 768) {
        this.$router.push(route)
      }
    },
    changeSideBarState () {
      let value = this.isSideBarExpanded ? 'nonexpanded' : 'expanded'
      this.$store.dispatch({ type: 'setSideBarState', value: value })
    },
    isSubRouterLinkActive (routerName) {
      if (typeof routerName === 'string') {
        return routerName === this.currentRoute.name || routerName === this.currentRoute.meta.parent
      } else {
        return routerName.filter(item => item === this.currentRoute.name || item === this.currentRoute.meta.parent).length !== 0
      }
    }
  }
}
</script>

<style lang="stylus">
.as
  fixed left top
  height 100vh
  background $dark
  text-align center
  transition all 0.3s
  z-index 102
  width 280px
  display flex
  flex-direction column

  &.shrink
    width 100px

    +below(768px)
      left 0

      &.active
        left -100px

  &__logo
    display flex
    align-items center
    justify-content center
    flex 1

    svg

      #logo__text
        display none

    ^[0].shrink &
      display none

    &__container
      display flex
      width 100%
      background $white
      border-right 1px solid $pinky

  &__toggle
    display flex
    flex-shrink 0
    align-items center
    justify-content center
    padding 27px 30px

    ^[0].shrink &
      width 100%

    +below(540px)
      height 60px

  &__items
    -ms-overflow-style none
    scrollbar-width 0

  &__item
    display flex
    align-items flex-start
    justify-content flex-start
    padding 20px 15px
    flex-shrink 0

    ^[0].shrink &
      padding 10px 0

    &__bottom
      background rgba($white, 0.1)
      padding 15px

    &s
      display flex
      flex-direction column
      justify-content space-between
      padding-bottom 10px
      height calc(100vh - 80px)
      flex-shrink 0
      overflow-y scroll
      overflow-x hidden

      ^[0].shrink &
        +below(540px)
          padding 0
          height calc(100vh - 135px)

  &__submenu
    display flex
    flex-direction column
    padding 0 0 0 60px

    ^[0].shrink &
      min-width 200px
      display none
      background: $c4E555A
      box-shadow: 0 20px 30px rgba($c4E555A, 0.17);
      border-radius: 0 3px 3px 0;
      padding: 0
      z-index 99
      position fixed
      left 90px

      +below(576px)
        left 100px

      li
        cursor pointer
        &:hover
          span
            color $orange

      li:not(:last-child)
        border-bottom 1px solid $pinky

    &__link
      font-size: 15px;
      line-height: 18px;
      color: $pinky;
      position relative
      display flex
      align-items center
      width 100%
      padding 10px 0
      cursor pointer
      transition color 0.3s ease
      &:hover
       color $orange

      span
        color $orange

      .as__menu__link__icon
        svg
          path[fill]
            fill $orange !important
          path
            stroke $orange !important
          circle
            stroke $orange !important
          polygon
            stroke $orange !important
          line
            stroke $orange !important
          ellipse
            stroke $orange !important

      ^[0].shrink &
        padding 22px 16px

      &.active
        color $orange

        svg path[fill]
          fill $orange

        svg path
          stroke $orange

        svg polygon
          stroke $orange

        svg line
          stroke $orange

      &:before
        content ""
        width 5px
        height 5px
        border-radius 100%
        background $white
        display flex
        absolute left -15px

        ^[0].shrink &
          display none

  &__menu
    display flex
    flex-direction column
    padding 0 5px
    width 100%
    z-index 100

    li
      display flex
      flex-direction column
      align-items flex-start
      justify-content flex-start
      position relative

      input
        height 0
        width 0
        border none
        visibility hidden
        &:checked + .as__submenu
          display block

      &:has(input:checked) .as__menu__link
        color $orange

        svg path[fill]
          fill $orange

        svg path
          stroke $orange

        svg polygon
          stroke $orange

        svg line
          stroke $orange

    &__link
      display flex
      align-items center
      justify-content flex-start
      padding 20px 15px
      width 100%
      font-size: 17px
      line-height: 21px
      color: $gray
      border-radius: 10px
      position relative
      cursor pointer

      &:hover
        span
          color $orange

        .as__menu__link__icon
            svg
              path[fill]
                fill $orange !important
              path
                stroke $orange !important
              circle
                stroke $orange !important
              polygon
                stroke $orange !important
              line
                stroke $orange !important
              ellipse
                stroke $orange !important

      +below(576px)
        justify-content center

      &.show_in_mobile
        display none

      ^[0].shrink &
        flex-direction column
        align-items center
        justify-content center
        font-size: 11px;
        line-height: 13px;
        color: $gray;
        padding 10px 0

      &.active
        background rgba($white, 0.1)
        span
          color $orange
        .as__menu__link__icon
          svg
            path[fill]
              fill $orange !important
            path
              stroke $orange !important
            circle
              stroke $orange !important
            polygon
              stroke $orange !important
            line
              stroke $orange !important
            ellipse
              stroke $orange !important
      &__icon
        width 24px
        height 24px
        display flex
        align-items center
        flex-shrink 0

      &__title
        padding-left 20px
        text-align left

        ^[0].shrink &
          padding-left 0
          padding-top 10px
          text-align center

      &__badge
        display flex
        align-items center
        justify-content center
        font-size: 15px
        line-height: 18px
        min-width 30px
        height 30px
        background $red
        border-radius 100%
        position relative
        top -10px
        right -5px
        padding 0 5px
        color $white !important

        ^[0].shrink &
          position: absolute;
          right: 10px;
          top: -5px;

        &--orange
          background $orange

        &--less-rounded
          border-radius 40%
</style>
